
namespace GeniuzPOS.Product {
    import fld = GeniuzPOS.Product.ReportExportV1Row.Fields;

    @Serenity.Decorators.registerClass()
    export class ReportExportV1Grid extends Serenity.EntityGrid<ReportExportV1Row, any> {
        protected getColumnsKey() { return ReportExportV1Columns.columnsKey; }
        protected getDialogType() { return ReportExportV1Dialog; }
        protected getIdProperty() { return ReportExportV1Row.idProperty; }
        protected getInsertPermission() { return ReportExportV1Row.insertPermission; }
        protected getLocalTextPrefix() { return ReportExportV1Row.localTextPrefix; }
        protected getService() { return ReportExportV1Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportExportV1Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation 
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/Product/SkuHd';
                        return false;
                    },
                }
            );    

            return buttons;
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.CreateDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            Q.first(filters, x => x.field == fld.CreateBy).init = w => {
                var userId = Authorization.userDefinition.Username;
                (w as Serenity.LookupEditor).value = userId;
            };

            return filters;
        }
    }
}